export default __webpack_public_path__ + "static/media/weatherchecker.07a849be.gif";